import * as React from 'react';
import {Switch, Route} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {ForgotPasswordPage} from './forgot-password/forgot-password-page';
import {LoginPage} from './login-page';
import {NewLoginLayout} from './new-login-layout';
import {ResetSuccessPage} from './reset-success/reset-success-page';
import {SetNewPasswordPage} from './set-new-password/set-new-password-page';
import {getMultiAccountLoginMode} from './types';

/*
 * This is the top-level ui component for pages associated with the login flow
 */
export class LoginRoot extends React.Component<Record<any, any>> {
    render() {
        const loginMode = this.props.match.isExact ? getMultiAccountLoginMode() : null;
        const pageContent = (
            <Switch>
                <Route path='/auth/forgot-password' component={ForgotPasswordPage} />
                <Route
                    path='/auth/reset-password'
                    render={(props: ContextRouter) => (
                        <SetNewPasswordPage {...props} isNewUser={false} />
                    )}
                />
                <Route path='/auth/reset-success' component={ResetSuccessPage} />
                <Route
                    path='/auth/get-started'
                    render={(props: ContextRouter) => (
                        <SetNewPasswordPage {...props} isNewUser={true} />
                    )}
                />
                <Route
                    path='/auth'
                    exact={true}
                    render={() => <LoginPage loginMode={loginMode} />}
                />
            </Switch>
        );

        return <NewLoginLayout form={pageContent} loginMode={loginMode} />;
    }
}
